import React from 'react';

type Props = {
    fileName: string,
    fileContents: string
}

const HighlightedCode = (props: Props) => {

    let fileType = props.fileName.split('\.').pop() || '';

    if (!['java', 'html', 'css', 'php', 'json', 'sql', 'js'].includes(fileType)) {
        fileType = 'plaintext';
    }

    const highlight = (e: any) => {
        if (e && window['hljs']) {
            window['hljs'].highlightElement(e);
        }
    }

    return <pre><code ref={highlight}
        className={"language-" + fileType}>{props.fileContents}</code></pre>;

};

export default HighlightedCode;
